var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8749 0H19.8749C19.2569 0 18.3914 0.3585 17.9549 0.795L6.79642 11.9535C6.58602 12.1649 6.4679 12.451 6.4679 12.7493C6.4679 13.0475 6.58602 13.3336 6.79642 13.545L16.4549 23.2035C16.6663 23.4139 16.9524 23.532 17.2507 23.532C17.5489 23.532 17.835 23.4139 18.0464 23.2035L29.2049 12.045C29.6429 11.607 29.9999 10.743 29.9999 10.125V1.125C29.9991 0.826875 29.8803 0.541187 29.6695 0.33038C29.4587 0.119573 29.173 0.000791837 28.8749 0V0ZM23.2499 9C22.9543 8.9999 22.6617 8.94159 22.3887 8.82839C22.1156 8.71518 21.8675 8.54931 21.6586 8.34024C21.4497 8.13117 21.284 7.88299 21.171 7.60988C21.0579 7.33677 20.9998 7.04407 20.9999 6.7485C21 6.45293 21.0583 6.16027 21.1715 5.88723C21.2847 5.6142 21.4506 5.36613 21.6597 5.1572C21.8687 4.94827 22.1169 4.78256 22.39 4.66954C22.6631 4.55652 22.9558 4.4984 23.2514 4.4985C23.8484 4.4987 24.4208 4.73602 24.8427 5.15826C25.2647 5.5805 25.5016 6.15306 25.5014 6.75C25.5012 7.34694 25.2639 7.91934 24.8417 8.3413C24.4194 8.76326 23.8469 9.0002 23.2499 9Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 12.75L15.7499 0H13.8749C13.2569 0 12.3914 0.3585 11.9549 0.795L0.796417 11.9535C0.586015 12.1649 0.467896 12.451 0.467896 12.7493C0.467896 13.0475 0.586015 13.3336 0.796417 13.545L10.4549 23.2035C10.6663 23.4139 10.9524 23.532 11.2507 23.532C11.5489 23.532 11.835 23.4139 12.0464 23.2035L12.7514 22.4985L3.00142 12.7485L2.99992 12.75Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagIcon);
export default __webpack_public_path__ + "static/media/price-tag-icon.4b63c2e79fe67c9eaf578d42ddbc5ce8.svg";
export { ForwardRef as ReactComponent };